import React from "react";
import logo from "./header_ic.png"

export function Header(props) {
    return (
        <h1 id="header" style={{ backgroundImage: `url(${logo})` }}>
            <span>{props.label}</span>
        </h1>
    );
}